import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import ResourceType from '../../types/resource';

import './thumb-list-item.css';

const ThumbListItem = ({ isSelected, resource, onSelect, onChangeLocation }) =>
{
  const {
    name,
    thumbSrc,
    isDirectory,
    isDocument,
    isImage
  } = resource;

  const itemClass = classnames({
    'resource-dialog__thumb-list-item': true,
    'resource-dialog__thumb-list-item_selected': isSelected
  });

  const itemPicturesClass = classnames({
    'resource-dialog__thumb-list-item-picture': true,
    'resource-dialog__thumb-list-item-picture_directory': isDirectory,
    'resource-dialog__thumb-list-item-picture_document': isDocument,
    'resource-dialog__thumb-list-item-picture_file': !isDirectory
  });

  const imageBackgroundStyles = isImage ? { backgroundImage: `url('${thumbSrc}')` } : {};
  return (
    <div className={itemClass} onClick={onSelect} onDoubleClick={onChangeLocation}>
      <div className="resource-dialog__thumb-list-item-container">
        <div className="resource-dialog__thumb-list-item-picture-container">
          <div
            className={itemPicturesClass}
            style={imageBackgroundStyles}
          />
        </div>
        <div className="resource-dialog__thumb-list-item-title">
          {name}
        </div>
      </div>
    </div>
  );
};

ThumbListItem.propTypes = {
  isSelected: PropTypes.bool,
  onSelect: PropTypes.func.isRequired,
  onChangeLocation: PropTypes.func.isRequired,
  resource: ResourceType.isRequired
};

ThumbListItem.defaultProps = {
  isSelected: false
};

export default ThumbListItem;